import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  REQUEST_FORM_FIELD_NAME_TITLE,
  REQUEST_FORM_TITLE_FIELD_MAX_LENGTH,
} from '../../RequestForm.constants'

import * as styles from '../RequestFormFields.module.css'

function TitleField({ requiredFields, ...restProps }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...restProps}
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Request.TitleLabelKey')}:`,
        required: requiredFields.includes(REQUEST_FORM_FIELD_NAME_TITLE),
        shouldAdaptToMobileScreen: true,
      }}
      inline={!!isMobileScreenSize}
      maxLength={REQUEST_FORM_TITLE_FIELD_MAX_LENGTH}
      name={REQUEST_FORM_FIELD_NAME_TITLE}
      placeholder={t('Request.TitlePlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default TitleField
